var map = {
	"./GreyhoundRaces_light_bg.jpg": "./src/assets/GreyhoundRaces_light_bg.jpg",
	"./VirtualGreyhoundRaces_light_bg.jpg": "./src/assets/VirtualGreyhoundRaces_light_bg.jpg",
	"./VirtualHorseRaces_light_bg.jpg": "./src/assets/VirtualHorseRaces_light_bg.jpg",
	"./VirtualMotorcycleSpeedway_light_bg.jpg": "./src/assets/VirtualMotorcycleSpeedway_light_bg.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*_light_bg\\.jpg$";